import React from "react";

import { ZeosRadioGroup } from "../../../components/Shared/ZeosRadioGroup";
import { OnboardingSummaryRow } from "../../../services/survey/OnboardingSurveySummaryHelpers";

export type DeeperPathChoice = "sufficient" | "comprehensive";

interface IProps {
  heading: string;
  body: string;
  rows: OnboardingSummaryRow[];
  deeperPathChoice: DeeperPathChoice;
  onDeeperPathChange: (choice: DeeperPathChoice) => void;
  domainTitle: string;
}

export const OnboardingSurveyCompletion: React.FC<IProps> = ({
  heading,
  body,
  rows,
  deeperPathChoice,
  onDeeperPathChange,
  domainTitle,
}) => {
  const deeperPathOptions = [
    "This is sufficient for now",
    `Continue to the comprehensive ${domainTitle} Survey`,
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold text-zeos-black">{heading}</h2>
        <p className="text-sm text-gray-600 mt-2">{body}</p>
      </div>

      {rows.length > 0 && (
        <div className="space-y-3">
          {rows.map((row) => (
            <div
              key={row.label}
              className="border-l-4 border-zeos-orange-md pl-4 py-2"
            >
              <div className="text-sm font-semibold text-zeos-black">
                {row.label}
              </div>
              <div className="text-sm text-gray-600 mt-1">{row.value}</div>
            </div>
          ))}
        </div>
      )}

      <div className="space-y-4 border-t border-gray-200 pt-6">
        <div>
          <div className="text-2xl font-semibold text-zeos-black">
            Want to tell ZEOS-AI more?
          </div>
        </div>
        <div className="border-l-4 border-zeos-orange-md pl-4 py-2">
          <ZeosRadioGroup
            name="onboarding-deeper-path"
            options={deeperPathOptions}
            value={
              deeperPathChoice === "comprehensive"
                ? deeperPathOptions[1]
                : deeperPathOptions[0]
            }
            onChange={(value) => {
              onDeeperPathChange(
                value === deeperPathOptions[1] ? "comprehensive" : "sufficient"
              );
            }}
            layout="vertical"
          />
        </div>
      </div>
    </div>
  );
};
